import React, { useMemo } from "react";
import { shallowEqual } from "react-redux";
import ChatWrapper from "./ChatWrapper";
import { ChatsUIProvider } from "./context/ChatsContext";
import { useChatSelector } from "./hooks/reduxHook";

import "./style/index.css";

const ChatSystem = () => {
  const { userInfo, isOpen } = useChatSelector(
    (state: any) => ({
      userInfo: state.userInfo,
      isOpen: state.chats.isOpen,
    }),
    shallowEqual
  );

  const isVisible = useMemo(() => userInfo && isOpen, [userInfo, isOpen]);

  if (!isVisible) return null;

  return (
    <ChatsUIProvider>
      <ChatWrapper />
    </ChatsUIProvider>
  );
};

export default ChatSystem;
